import React from "react";
import {Icon} from "gd-react";
import {deliveryStatus} from "../../../services/dataRequestTypes";
import "./DeliveryStatusCell.scss";

// Icon passes a colour it does not recognise straight through, which is where the amber comes from:
// the palette has no orange, and retrying is not the same thing as having given up.
const ICONS = {
    delivered: {icon: 'FaCheckCircle', color: 'gd-green'},
    retrying: {icon: 'FaExclamationCircle', color: '#ef6c00'},
    failed: {icon: 'FaTimesCircle', color: 'gd-red'},
    pending: {icon: 'FaClock', color: 'gd-grey'}
};

// The error itself is the point, so it is rendered next to the icon rather than left in a tooltip.
class DeliveryStatusCell extends React.Component {
    render() {
        const status = deliveryStatus(this.props.object, this.props.notificationConfig);
        const maxWidth = this.props.maxWidth ? this.props.maxWidth : '250px';
        if (!status) {
            return <div className={"list-field delivery-status-cell"} style={{maxWidth: maxWidth}}/>;
        }
        const appearance = ICONS[status.state];
        return (
            <div className={"list-field delivery-status-cell " + status.state}
                 title={status.message}
                 style={{maxWidth: maxWidth}}>
                <Icon size={'14'} color={appearance.color} icon={appearance.icon}/>
                <span className={'delivery-status-message'}>{status.message}</span>
            </div>
        );
    }
}

export default DeliveryStatusCell;
